import { useTheme } from "@mui/material";
import { useGoalsRightOptional } from "web_myplann/Api/Rights/RightsProvider";

export const useFlatRowValueColor = (): string => {
	const { palette } = useTheme();
	const hasGoalsRight = useGoalsRightOptional();

	return hasGoalsRight ? palette.grey[900] : palette.blue[600];
};
